export default __webpack_public_path__ + "static/ABA_2021-Finalist__OFFICE OF THE YEAR – NON-FRANCHISE-9bde185f57df1d54f5517fcc02a9624c.png";